module.exports = __webpack_public_path__ + "img/case-1-tablet.f629969.jpg";